// @ts-nocheck
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

export const getWebsite = (state: ApplicationState) => {
    return state.context.website;
};

export const getWebsiteName = (state: ApplicationState) => {
    return getWebsite(state).name;
};

export const getIsAuthenticated = (state: ApplicationState) => {
    const session = getSession(state);

    return session && session.isAuthenticated;
};

export const getSignInRequiredToAddToCartOrSeePrices = (state: ApplicationState) => {
    const productSettings = getSettingsCollection(state).productSettings;
    return productSettings.storefrontAccess === StorefrontAccess.SignInRequiredToAddToCartOrSeePrices;
};

export const getIsSignedInAndhasToBeSignedIn = (state: ApplicationState) => {
    const isAuthenticated = getIsAuthenticated(state);
    const signInRequiredToAddToCartOrSeePrices = getSignInRequiredToAddToCartOrSeePrices(state);

    if (signInRequiredToAddToCartOrSeePrices) {
        return isAuthenticated;
    }

    return true;
};

export const getCanShowInventory = (state: ApplicationState) => {
    return getSettingsCollection(state).productSettings.showInventoryAvailability;
};

export const getallowShipToAddressEdit = (state: ApplicationState) => {
    return getSettingsCollection(state).customerSettings.allowShipToAddressEdit;
};

export const getallowBillToAddressEdit = (state: ApplicationState) => {
    return getSettingsCollection(state).customerSettings.allowBillToAddressEdit;
};

export const getGreifOrderHistoryExportSettings = (state: ApplicationState) => {
    return getSettingsCollection(state).greifOrderHistoryExportSettings;
};

export const getGreifInvoiceExportSettings = (state: ApplicationState) => {
    return getSettingsCollection(state).greifInvoiceHistoryExportSettings;
};

export const getIsAccessoryUpsellEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).featureFlagsSettings?.enableAccessoryUpsell ?? false;
};

export const getIsCartRedesignEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).featureFlagsSettings?.enableCartRedesign ?? false;
};

export const getIsCheckoutTaxAlertEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).featureFlagsSettings?.enableCheckoutTaxAlert ?? false;
};

export const getIsPackagingAdviceEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).featureFlagsSettings?.enablePackagingAdvice ?? false;
};

export const getIsSimpleRequestQuoteEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).featureFlagsSettings?.enableSimpleRequestQuote ?? false;
};

export const getIsMaintenanceBannerEnabled = (state: ApplicationState) => {
    return getSettingsCollection(state).maintenanceBannerSettings?.enableMaintenanceBanner ?? false;
};
